// Marketplaces offered (Keepa domain ids) and the filter form per tab, in the
// Helium 10 Black Box layout the prototype used.
export const MARKETPLACES = [
  { domain: 10, label: '🇮🇳 India (amazon.in)', currency: '₹', step: 50 },
  { domain: 1, label: '🇺🇸 United States (amazon.com)', currency: '$', step: 5 },
  { domain: 2, label: '🇬🇧 United Kingdom (amazon.co.uk)', currency: '£', step: 5 },
  { domain: 15, label: '🇦🇪 UAE (amazon.ae)', currency: 'AED ', step: 10 },
  { domain: 3, label: '🇩🇪 Germany (amazon.de)', currency: '€', step: 5 },
  { domain: 6, label: '🇨🇦 Canada (amazon.ca)', currency: 'CAD $', step: 5 },
];

export const TABS = [
  { key: 'active', label: 'Find Active Products' },
  { key: 'oos', label: 'Find Out of Stock Products' },
];

export const TARGET_COUNTS = [50, 100, 200];
export const SCAN_LIMITS = [200, 300, 500];
export const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const COUNTRIES = ['IN', 'CN', 'US', 'HK', 'GB', 'AE', 'SG', 'DE', 'JP', 'KR', 'TW'];
export const DEEP_HELP = 'Needs Deep data (search settings).';

// type: range | signed (may be negative) | multi | text | select | identifiers | months | dates
// tabs: where the field shows (default both). deep: needs Deep data. money: label gets the currency.
export const FILTER_COLUMNS = [
  {
    title: 'Product',
    fields: [
      { key: 'review_count', label: 'Review Count', type: 'range', step: 10 },
      { key: 'rating', label: 'Review Rating', type: 'range', step: 0.1 },
      { key: 'bsr', label: 'Best Seller Rank (BSR)', type: 'range', step: 1000, tabs: ['active'] },
      { key: 'listing_age_months', label: 'Listing Age (Months)', type: 'range' },
      { key: 'shipping_sizes', label: 'Shipping Size', type: 'multi', options: ['Standard', 'Oversize'] },
      { key: 'weight_kg', label: 'Weight (kg)', type: 'range', step: 0.1 },
      {
        key: 'fulfillment', label: 'Fulfillment', type: 'multi', options: ['FBA', 'FBM', 'Amazon'], deep: true,
        help: 'Keepa gives FBA vs FBM only with the buy box data.',
      },
      {
        key: 'frequently_returned', label: 'Frequently Returned Item Badge', type: 'select',
        options: ['All', 'Yes', 'No'], tabs: ['active'],
        help: 'From the Keepa return-rate field; products without it count as unknown.',
      },
      { key: 'image_count', label: 'Number of Images', type: 'range' },
      { key: 'variation_count', label: 'Variation Count', type: 'range' },
      { key: 'title_keywords', label: 'Title Keywords', type: 'text', placeholder: 'Ex: red dress (comma = any of)' },
      { key: 'exclude_title_keywords', label: 'Exclude Title Keywords', type: 'text', placeholder: 'Ex: red, blue' },
      {
        key: 'identifiers', label: 'Product Identifiers', type: 'identifiers',
        placeholder: 'ASIN / UPC / GTIN / EAN / ISBN, one per line',
        help: 'When filled, these products are looked up directly instead of searching.',
      },
    ],
  },
  {
    title: 'Competitors',
    fields: [
      { key: 'sellers', label: 'Number of Sellers', type: 'range', tabs: ['active'] },
      { key: 'brands', label: 'Exact Brand Search', type: 'text', placeholder: 'Ex: Milton (comma-separate several)' },
      { key: 'exclude_brands', label: 'Exclude Brands', type: 'text', placeholder: 'Ex: Cello' },
      { key: 'sellers_include', label: 'Exact Seller Search', type: 'text', placeholder: 'Ex: Cloudtail India', deep: true },
      { key: 'sellers_exclude', label: 'Exclude Seller', type: 'text', placeholder: 'Ex: Appario Retail', deep: true },
      {
        key: 'seller_countries', label: 'Exact Seller Country/Region', type: 'multi', options: COUNTRIES, deep: true,
        help: 'Often blank on amazon.in.',
      },
      { key: 'exclude_seller_countries', label: 'Exclude Seller Country/Region', type: 'multi', options: COUNTRIES, deep: true },
    ],
  },
  {
    title: 'Sales',
    fields: [
      { key: 'price', label: 'Price', oosLabel: 'Latest Price', type: 'range', money: true, priceStep: true },
      { key: 'price_change_pct', label: 'Price Change (%) — 90 days', type: 'signed', tabs: ['active'] },
      { key: 'parent_revenue', label: 'Parent Level Revenue', type: 'range', step: 10000, money: true, deep: true, tabs: ['active'] },
      { key: 'asin_revenue', label: 'ASIN Revenue', type: 'range', step: 10000, money: true, tabs: ['active'] },
      { key: 'parent_units', label: 'Parent Level Sales (units)', type: 'range', step: 50, deep: true, tabs: ['active'] },
      { key: 'asin_units', label: 'ASIN Sales (units / mo)', type: 'range', step: 50, tabs: ['active'] },
      { key: 'sales_change_pct', label: 'Sales Change (%) — 90 days', type: 'signed', tabs: ['active'] },
      { key: 'yoy_pct', label: 'Sales Year over Year (%)', type: 'signed', tabs: ['active'] },
      { key: 'best_sales_months', label: 'Best Sales Month', type: 'months', tabs: ['active'] },
      { key: 'sales_to_reviews', label: 'Sales to Reviews Ratio', type: 'range', step: 0.5, tabs: ['active'] },
      { key: 'parent_revenue_t360', label: 'Parent Level Revenue (T360)', type: 'range', step: 10000, money: true, deep: true, tabs: ['oos'] },
      { key: 'asin_revenue_t360', label: 'ASIN Revenue (T360)', type: 'range', step: 10000, money: true, tabs: ['oos'] },
      { key: 'parent_units_t360', label: 'Parent Level Sales (T360)', type: 'range', step: 100, deep: true, tabs: ['oos'] },
      { key: 'asin_units_t360', label: 'ASIN Sales (T360)', type: 'range', step: 100, tabs: ['oos'] },
      { key: 'last_active', label: 'Last Active Age (last day in stock)', type: 'dates', tabs: ['oos'] },
    ],
  },
];

export const SOURCE_LABELS = { keepa: 'Keepa', cache: 'Cache (free)', demo: 'Demo estimate' };

export const countLabel = (n) => {
  if (!n) return '–';
  if (n >= 1000000) return `${(n / 1000000).toFixed(1)}M products`;
  if (n >= 1000) return `${Math.round(n / 1000)}K products`;
  return `${n} products`;
};

export const fieldShows = (field, tab) => !field.tabs || field.tabs.includes(tab);

// Form values -> the JSON the API takes: ranges [min, max] with null for blank,
// lists for comma / line separated text, months as 1..12.
export const buildFilterPayload = (values, tab, deepData, categories) => {
  const out = { categories };
  FILTER_COLUMNS.forEach((col) => col.fields.forEach((f) => {
    if (!fieldShows(f, tab) || (f.deep && !deepData)) return;
    const v = values[f.key];
    if (v === undefined || v === null || v === '') return;
    switch (f.type) {
      case 'range':
      case 'signed':
      case 'dates': {
        const lo = v[0] === '' || v[0] === undefined ? null : v[0];
        const hi = v[1] === '' || v[1] === undefined ? null : v[1];
        if (lo === null && hi === null) return;
        out[f.key] = f.type === 'dates' ? [lo, hi] : [lo === null ? null : Number(lo), hi === null ? null : Number(hi)];
        return;
      }
      case 'text': {
        const list = v.split(',').map((s) => s.trim()).filter(Boolean);
        if (list.length) out[f.key] = list;
        return;
      }
      case 'identifiers': {
        const list = v.split(/[\s,;]+/).map((s) => s.trim()).filter(Boolean);
        if (list.length) out[f.key] = list;
        return;
      }
      case 'months':
        if (v.length) out[f.key] = v.map((m) => MONTHS.indexOf(m) + 1);
        return;
      case 'multi':
        if (v.length) out[f.key] = v;
        return;
      case 'select':
        if (v !== 'All') out[f.key] = v;
        return;
      default:
    }
  }));
  return out;
};
